import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { messages } from './SingleSignOnLogoutForm.i18n';
import { loadSupportedLanguages } from '../../redux/modules/capability/capability-middleware';

class SingleSignOnLogoutForm extends Component {
  UNSAFE_componentWillMount() {
    this.props.dispatch(loadSupportedLanguages());
  }

  render() {
    const { formatMessage } = this.props.intl;
    const text = formatMessage(messages.page.singleSignOnLogout);
    return (
      <div className="container">
        <div className="row" id="body">
           <div className="col">
             <div className="row justify-content-md-center mt-3">
                <div className="col-md-8 col-xl-6">
                  <h1 id="content">
                    <FormattedMessage {...messages.page.singleSignOnLogoutTitle} />
                  </h1>
                  <div className="card p-3">
                    <div className="card-body">
                      <div className="content-area">
                        <div dangerouslySetInnerHTML={{ __html: text }}
                          tabIndex="0"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
             </div>
           </div>
        </div>
      </div>
    );
  }
}

SingleSignOnLogoutForm.propTypes = {
  dispatch: PropTypes.func,
  language: PropTypes.object.isRequired,
  supportedLanguages: PropTypes.array.isRequired,
  intl: PropTypes.object,
};

const mapStateToProps = (state) => ({
  language: state.language,
  supportedLanguages: state.capability.languages,
});

export default connect(mapStateToProps)(injectIntl(SingleSignOnLogoutForm));